namespace $ { $mol_style_attach( "mol/bar/bar.view.css",
 "[mol_bar] {\n\tdisplay: flex;\n\t/* box-shadow: inset 0 0 0 1px var(--mol_theme_line); */\n\tborder-radius: var(--mol_gap_round);\n}\n"
) }